export const LogoMark = ({ className = "w-9 h-9" }) => (
  <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <path d="M20 3L35 11.66V28.34L20 37L5 28.34V11.66L20 3Z" stroke="#F97316" strokeWidth="2.5" strokeLinejoin="bevel" />
    <circle cx="20" cy="20" r="6" stroke="#E2E8F0" strokeWidth="2" />
    <path d="M20 7V14M20 26V33M8 20H15M25 20H32" stroke="#F97316" strokeWidth="2" strokeLinecap="square" />
    <rect x="18" y="18" width="4" height="4" fill="#F97316" />
  </svg>
);

export const Logo = ({ compact = false }) => (
  <span className="flex items-center gap-3">
    <LogoMark className={compact ? "w-8 h-8" : "w-9 h-9"} />
    <span className="leading-none">
      <span className="block font-display font-black uppercase tracking-tight text-[17px] text-slate-50">
        The Mechanic's
      </span>
      <span className="block font-display font-bold uppercase tracking-[0.28em] text-[11px] text-blaze">
        Tool Kit
      </span>
    </span>
  </span>
);
